<div class="content">

    <header class="padding">
        <span> SAFE TRACK </span>

        <div class=logos-box>
            <div class="logo">
                <img src="../../../assets/landing-page/safetrace-logo.png" alt="SafeTrace">
            </div>
    
            <div class="logo" style="height: clamp(10%, 40%, 70%);">
                <img src="../../../assets/landing-page/qima-logo.svg" alt="QIMA">
            </div>
    
            <div class="logo">
                <img src="../../../assets/landing-page/safebeef-logo.png" alt="SafeBeef">
            </div>
        </div>
    </header>

    <section class="intro1 padding">
        <div class="text1">
            <h1 class="title" style="letter-spacing: 3px;"> Soluções Líderes <br> em Rastreabilidade e Segurança do
                Alimento
            </h1>
        </div>

        <div class="text2">
            <p style="letter-spacing: 2px;"> Fortalecendo o comércio global com identificação, <br> rastreabilidade e
                sustentabilidade
                em toda a <br> cadeia de fornecedimento
            </p>
        </div>

        <div class="text3">
            <button (click)="openFormMessage('Fale com um Especialista')"> Fale com um Especialista
                <i> <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M18.378 27.759C19.3274 27.6941 20.2688 27.5425 21.1905 27.306C22.3289 27.6482 23.5305 27.7257 24.7035 27.5325C24.7503 27.5268 24.7974 27.5233 24.8445 27.522C25.263 27.522 25.812 27.762 26.613 28.2675V27.4365C26.6133 27.2917 26.6525 27.1497 26.7264 27.0252C26.8002 26.9007 26.9061 26.7982 27.033 26.7285C27.382 26.5315 27.7045 26.31 28.0005 26.064C29.1675 25.089 29.826 23.787 29.826 22.41C29.826 21.9555 29.754 21.5025 29.6115 21.0705C29.9655 20.4195 30.2475 19.74 30.4575 19.032C31.1325 20.0295 31.4955 21.207 31.5 22.41C31.5 24.282 30.618 26.028 29.0895 27.3045C28.8335 27.5175 28.566 27.7135 28.287 27.8925V29.8395C28.287 30.5085 27.504 30.894 26.952 30.495C26.429 30.1102 25.8884 29.7498 25.332 29.415C25.1713 29.3223 25.0049 29.2397 24.834 29.1675C24.3697 29.2363 23.9009 29.2709 23.4315 29.271C21.5265 29.271 19.7655 28.7055 18.378 27.759ZM8.2965 23.8665C5.8905 21.852 4.5 19.1055 4.5 16.1625C4.5 10.1505 10.248 5.34302 17.2665 5.34302C24.2865 5.34302 30.036 10.149 30.036 16.1625C30.036 22.1745 24.2865 26.9805 17.2665 26.9805C16.4775 26.9805 15.7 26.9205 14.934 26.8005C14.604 26.877 13.281 27.6525 11.376 29.025C10.686 29.523 9.708 29.043 9.708 28.2045V24.885C9.21393 24.5796 8.74269 24.2387 8.298 23.865M14.9805 24.753C15.0385 24.753 15.097 24.7575 15.156 24.7665C15.846 24.8805 16.5495 24.938 17.2665 24.939C23.196 24.939 27.9405 20.9715 27.9405 16.161C27.9405 11.352 23.196 7.38452 17.268 7.38452C11.34 7.38452 6.5925 11.355 6.5925 16.1625C6.5925 18.4875 7.7025 20.6775 9.6615 22.317C10.1555 22.729 10.6935 23.099 11.2755 23.427C11.4334 23.5146 11.5652 23.6426 11.6574 23.7978C11.7496 23.953 11.799 24.13 11.8005 24.3105V26.2245C13.308 25.227 14.2995 24.753 14.9805 24.753Z"
                            fill="white" />
                        <path
                            d="M12.093 18C12.5405 18 12.9698 17.8222 13.2862 17.5057C13.6027 17.1893 13.7805 16.7601 13.7805 16.3125C13.7805 15.8649 13.6027 15.4357 13.2862 15.1193C12.9698 14.8028 12.5405 14.625 12.093 14.625C11.6454 14.625 11.2162 14.8028 10.8997 15.1193C10.5833 15.4357 10.4055 15.8649 10.4055 16.3125C10.4055 16.7601 10.5833 17.1893 10.8997 17.5057C11.2162 17.8222 11.6454 18 12.093 18ZM17.5785 18C18.026 18 18.4553 17.8222 18.7717 17.5057C19.0882 17.1893 19.266 16.7601 19.266 16.3125C19.266 15.8649 19.0882 15.4357 18.7717 15.1193C18.4553 14.8028 18.026 14.625 17.5785 14.625C17.1309 14.625 16.7017 14.8028 16.3852 15.1193C16.0688 15.4357 15.891 15.8649 15.891 16.3125C15.891 16.7601 16.0688 17.1893 16.3852 17.5057C16.7017 17.8222 17.1309 18 17.5785 18ZM23.0625 18C23.51 18 23.9393 17.8222 24.2557 17.5057C24.5722 17.1893 24.75 16.7601 24.75 16.3125C24.75 15.8649 24.5722 15.4357 24.2557 15.1193C23.9393 14.8028 23.51 14.625 23.0625 14.625C22.6149 14.625 22.1857 14.8028 21.8692 15.1193C21.5528 15.4357 21.375 15.8649 21.375 16.3125C21.375 16.7601 21.5528 17.1893 21.8692 17.5057C22.1857 17.8222 22.6149 18 23.0625 18Z"
                            fill="white" />
                    </svg>
                </i>
            </button>
        </div>
    </section>

    <section class="intro2 padding">
        <div class="text1">
            <h2 class="title"> Introdução ao SafeTrack </h2>
        </div>

        <div class="text2">
            <p> O SafeTrack é a principal solução para <br> rastreabilidade e gestão de dados, com <br>
                know-how comprovado em todas as etapas <br>
                da cadeia de fornecimento. Desde a <br>
                identificação de animais até a integração <br>
                com o varejo, garantimos segurança, <br>
                eficiência e transparência. </p>
        </div>

        <div class="redbox">
            <span class="title" style="font-weight: bold; color: white;"> Pontos-Chave: </span>
            <ul>
                <li> Cobertura multi-cadeia: Carnes bovinas, suínas, aves, peixes, soja, café, entre outros. </li>
                <li> Integração com QR Code e Blockchain. </li>
                <li> Gestão de dados automatizada e armazenamento em sistemas seguros. </li>
            </ul>
        </div>

        <div class="cell"> </div>
    </section>

    <section class="middle1">
        <div class="white-part padding">
            <div class="differences">
                <span class="title"> Nossos <br> Diferenciais </span>

                <div class="image"> </div>
            </div>

            <div class="why">
                <span class="title" style="font-weight: bold;"> Por que Escolher o SafeTrack? </span>
                <ul class="redball">
                    <li> Monitoramento contínuo por satélite <br> e visitas regulares às fazendas. </li>
                    <li> Integração total com sistemas de certificação como <br> SISBOV, EUDR, GLOBALGAP, e outros.
                    </li>
                    <li> Dados detalhados sobre produção <br> animal, transporte e condições de manuseio.</li>
                    <li> Opções avançadas de controle via blockchain. </li>
                </ul>
            </div>
        </div>

        <div class="green-part padding">
            <div class="text1">
                <div class="red-white-box">
                    <span class="red-text"> +5milhões </span>
                    <span class="white-text"> de animais cadastrados </span>
                </div>
                <div class="red-white-box">
                    <span class="red-text"> 35.000 </span>
                    <span class="white-text"> fazendas monitoradas <br> anualmente </span>
                </div>
            </div>

            <div class="text2">
                <div class="red-white-box">
                    <span class="red-text"> 700+ </span>
                    <span class="white-text"> Inspeções de segurança <br> alimentar realizadas por ano </span>
                </div>
            </div>
        </div>
    </section>

    <section class="middle2">
        <div class="bull padding">
            <div class="redbox2">
                <span class="title" style="font-weight: bold; color: white;"> Funcionalidades <br> do SafeTrack </span>
            </div>

            <span class="title" style="color: white;"> Tecnologia de Ponta <br> para Rastreabilidade Total </span>

            <ul class="redball" style="color: white; margin-left: 1.7vw;">
                <li> Rastreabilidade completa desde a <br> matéria-prima até o produto final.</li>
                <li> Painéis personalizados com indicadores de gestão. </li>
                <li> Coleta automática de dados com <br> integração via app SafeBeef. </li>
                <li> Histórico detalhado de produção animal, <br> incluindo geolocalização, bem-estar e manejo. </li>
            </ul>
        </div>
    </section>

    <div class="line">
        QIMA - Certificação e Auditoria Global
    </div>

    <section class="middle1" style="background-color: #16380F; padding-bottom: clamp(40px, 7.80031vh, 60px);">
        <div class="about-qima padding">
            <div class="first-block">
                <div class="global-partners">
                    <span class="title" style="color: white; font-weight: bold;">
                        Parceiros Globais em <br> Segurança Alimentar
                    </span>
                    <ul class="redball" style="color: white; margin-left: 1.7vw;">
                        <li> A QIMA é uma referência mundial em <br> certificação e auditorias de segurança <br>
                            alimentar, com mais de 40.000 clientes <br> corporativos em 85 países. </li>
                    </ul>
                    <div class="logo" style="height: 14%;">
                        <img src="../../../assets/landing-page/qima-logo.svg" alt="QIMA">
                    </div>
                </div>

                <div class="datas">
                    <div class="red-white-box">
                        <span class="red-text"> 17.000+ </span>
                        <span class="white-text"> Certificados em <br> segurança alimentar <br> emitidos </span>
                    </div>
                    <div class="red-white-box">
                        <span class="red-text"> 7.126 </span>
                        <span class="white-text"> Auditorias realizadas </span>
                    </div>
                    <div class="red-white-box">
                        <span class="red-text"> 570.000 </span>
                        <span class="white-text"> Inspeções de produtos </span>
                    </div>
                </div>
            </div>

            <div class="second-block">
                <span class="title" style="color: white; font-weight: 500"> Quer transformar sua cadeia de fornecimento <br>
                    com segurança, transparência e eficiência? </span>

                <span class="title2" > Descubra como o <b> SafeTrack </b> pode agregar valor ao seu negócio </span>

                <div class="buttons-container">
                    <button (click)="openFormMessage('Solicitar Apresentação')" style="width: 35%;"> Solicitar Apresentação </button>
                    <button (click)="openFormMessage('Entre em Contato')" style="width: 35%;"> Entre em Contato </button>
                </div>
            </div>
        </div>
    </section>

    <div class="line" style="background-color: black; color:white">
        Soluções de ponta a ponta na cadeia de fornecimento
    </div>

    <section class="middle3">
        <div class="last-page padding">
            <div class="table">
                <img src="../../../assets/landing-page/table-bg.png" alt="">
            </div>

            <div class="texts-container">
                <div class="text1">
                    <h2 class="title"> RASTREABILIDADE em toda <br> a cadeia de suprimentos: </h2>
                </div>
        
                <div class="text2">
                    <p> Insumos, compra de animais, registros <br> sanitários e zootécnicos, abate, desossa, <br>
                         qualidade e identificação dos produtos. </p>
                </div>
            </div>
            
            <div class="logos-container">
                <button (click)="openFormMessage('Entre em Contato')"> Entre em Contato </button>
                <img style="width: 40%" src="../../../assets/landing-page/safetrace2-logo.png" alt="SafeTrace">
                <img style="width: 50%;" src="../../../assets/landing-page/qima-logo.svg" alt="QIMA">
                <img style="width: 50%;" src="../../../assets/landing-page/safebeef-logo.png" alt="SafeBeef">
            </div>

        </div>
    </section>

</div>
